import script from "./MST56_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST56_001INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__